import { css, cx } from '@linaria/atomic';
import { getBaseFontSize } from '@frontend/theme-original';
import { theme } from '@frontend/theme';
import { DirectionProps } from '../../hooks/types';

type DropdownProps = { active?: boolean } & DirectionProps;

type InputStyleProps = { isPlaceholder: boolean; disabled: boolean };

const BASE = getBaseFontSize();

const activeDropdownStyleBottom = css`
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
`;

const activeDropdownStyleTop = css`
  border-top-right-radius: 0;
  border-top-left-radius: 0;
`;

export const activeDropdownStyle = (placement = 'bottom') =>
  placement === 'bottom' ? activeDropdownStyleBottom : activeDropdownStyleTop;

export const placeholderStyle = css`
  color: ${theme.colors.neutral50};
`;

const inputBase = css`
  font-family: ${theme.font.family};
  font-size: ${theme.fontSize(16)};
  line-height: 1.375;
  padding-right: ${theme.spacing(4)};
  text-align: left;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  > input[type='text'] {
    margin-right: 0;
    padding-right: ${theme.spacing(3)};
    ::placeholder {
      color: ${theme.colors.neutral50};
    }
  }
`;

const inputPlaceholderStyle = css`
  color: ${theme.colors.neutral50};
`;

const inputDisabledStyle = css`
  color: ${theme.colors.status.disabled};
`;

export const inputStyle = ({ isPlaceholder, disabled }: Partial<InputStyleProps> = {}) =>
  cx(inputBase, isPlaceholder && inputPlaceholderStyle, disabled && inputDisabledStyle);

const upperBoxShadow = '1px -5px 14px 2px rgb(49 53 61 / 24%)';

const dropdownMenuBase = css`
  width: 100%;
  max-height: ${208 / BASE}rem;
  background: white;
  box-shadow: ${theme.shadows.heavy};
  border-radius: 0 ${theme.borderRadius.small};
  bottom: -1px;
  left: 0;
  overflow: auto;
  transform: translateY(100%);
  z-index: ${theme.zIndex.high};
  :focus {
    outline: none;
  }
  ::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }
  ::-webkit-scrollbar-thumb {
    background-color: ${theme.colors.neutral20};
    border-radius: ${theme.borderRadius.small};
  }
`;

const dropdownMenuDirectionUp = css`
  box-shadow: ${upperBoxShadow};
  border-radius: ${theme.borderRadius.small} 0;
  transform: translateY(-52px);
`;

const dropdownMenuInactive = css`
  z-index: ${theme.zIndex.base};
  pointer-events: none;
`;

export const dropdownMenuStyle = ({ direction, active }: DropdownProps) =>
  cx(dropdownMenuBase, direction === 'up' && dropdownMenuDirectionUp, !active && dropdownMenuInactive);

export const DropdownInputStyles = {
  inputStyle: (displayValue: Partial<InputStyleProps>) => inputStyle(displayValue ?? {}),
  dropdownMenuStyle: (dropdownProps: DropdownProps) => dropdownMenuStyle(dropdownProps),
  placeholderStyle,
};
